import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import FormGroup from 'react-bootstrap/FormGroup';
import FormLabel from 'react-bootstrap/FormLabel';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import PropTypes from 'prop-types';
import { i18n } from '../../i18n/translate.js';
import { FAIcon } from '../fa-icon/component.js';

var AvailableLanguagesField = /*#__PURE__*/function (_Component) {
  function AvailableLanguagesField(props) {
    _classCallCheck(this, AvailableLanguagesField);

    return _callSuper(this, AvailableLanguagesField, [props]);
  }

  _inherits(AvailableLanguagesField, _Component);

  return _createClass(AvailableLanguagesField, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          activeLanguage = _this$props.activeLanguage,
          defaultLanguage = _this$props.defaultLanguage,
          languages = _this$props.languages;

      if (this.props.isNewRecord && this.props.defaultLanguage) {
        languages = languages.filter(function (language) {
          return Object.keys(language)[0] === defaultLanguage;
        });
      }

      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "translate-rail"
      }, /*#__PURE__*/React.createElement(FormLabel, {
        className: "translate-label"
      }, i18n.t('Available Languages'), /*#__PURE__*/React.createElement("span", {
        className: "tooltip-container"
      }, /*#__PURE__*/React.createElement(OverlayTrigger, {
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip"
        }, i18n.t('Select a language to see that version of your content'))
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FAIcon, {
        icon: "circle-question",
        style: "regular"
      }))))), /*#__PURE__*/React.createElement("ul", {
        className: "list-unstyled"
      }, languages.map(function (language, i) {
        var locale = Object.keys(language)[0];
        return /*#__PURE__*/React.createElement("li", {
          key: i,
          onClick: function onClick() {
            return _this.props.onLanguageChange(language);
          },
          className: "".concat(String(activeLanguage).toLowerCase() === locale.toLowerCase() ? 'active ' : '', " ").concat(locale, " translate-language")
        }, language[locale], " ", defaultLanguage === locale ? i18n.t('(default)') : null);
      })));
    }
  }]);
}(Component);

_defineProperty(AvailableLanguagesField, "propTypes", {
  activeLanguage: PropTypes.string,
  languages: PropTypes.arrayOf(PropTypes.object),
  defaultLanguage: PropTypes.string,
  isNewRecord: PropTypes.bool,
  onLanguageChange: PropTypes.func.isRequired
});

_defineProperty(AvailableLanguagesField, "defaultProps", {
  languages: [{
    en: 'english'
  }]
});

AvailableLanguagesField.displayName = "AvailableLanguagesField";
export { AvailableLanguagesField };